<template>
  <section>
    <b-row v-if="activeBodyprint && userId">
      <b-col md="12">
        <matcher
          v-if="matchableUserId && (!products || products.length === 0)"
        />
        <matcher-multiple
          v-else-if="matchableUserId && products && products.length > 0"
        />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="12">
        <p>{{ $t("product-overview-no-bodyprint-found") }}</p>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="12" class="text-left">
        <b-button
          v-if="friendsVerification || groupsVerification"
          variant="link"
          @click="$router.push({ name: 'others' })"
          class="font-weight-bold"
        >
          <Frends class="mr-1" />
          <u>{{ $t("product-match-someone-else") }}</u>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-left">
        <b-button
          variant="link"
          @click="$store.dispatch('application/close')"
          class="font-weight-bold"
        >
          <CartBlack class="mr-1" />
          <u> {{ $t("product-match-continue-shopping") }}</u>
        </b-button>
      </b-col>
      <b-col md="12" class="mt-4">
        <last-measured />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import LastMeasured from "../../components/ui/last-measured";
import Matcher from "@/components/match/matcher";
import MatcherMultiple from "@/components/match/matcher-multiple";
import Frends from "../../assets/images/frends.svg";
import CartBlack from "../../assets/images/cart-black.svg";

export default {
  name: "pages-product-overview",
  components: {
    Matcher,
    LastMeasured,
    MatcherMultiple,
    Frends,
    CartBlack
  },
  data() {
    return {
      privacy_policy: {},
      terms_of_use: {}
    };
  },
  created() {
    this.$store.commit("ui/SET_LOADING_TEXT", "");
    this.$store.commit("ui/SET_LOADING", true);
    let getMe = this.$store
      .dispatch("users/getMe")
      .then(() => this.$store.commit("application/SET_MATCHABLE", this.userId));

    let privacy_policy = this.$store
      .dispatch("privacyPolicy/getLatestPrivacyPolicy")
      .then(pp => (this.privacy_policy = pp));
    let terms_of_use = this.$store
      .dispatch("termsOfUse/getLatestTermsOfUse")
      .then(tos => (this.terms_of_use = tos));
    let contacts = this.$store.dispatch("contacts/getContacts");
    let groups = this.$store.dispatch("groups/getGroups");
    Promise.all([
      getMe,
      privacy_policy,
      terms_of_use,
      groups,
      contacts
    ]).then(() => this.$store.commit("ui/SET_LOADING", false));
  },
  computed: {
    ...mapGetters({
      firstName: "users/getSelfFirstName",
      lastUpdatedAt: "users/getSelfLastUpdated",
      loadingAnimationActive: "ui/loadingAnimationActive",
      contacts: "contacts/getContacts",
      groups: "groups/getGroups",
      userId: "users/getSelfId",
      activeBodyprint: "users/getSelfBodyPrint",
      matchableUserId: "application/getMatchableUserId",
      products: "pageParams/getProducts"
    }),
    groupsVerification() {
      return (
        this.groups.some(group => group["has_members"] === true) &&
        this.groups.some(group => group["state"] === "owner")
      );
    },
    friendsVerification() {
      return this.contacts.some(friend => friend["active_bodyprint"] != null);
    }
  },
  watch: {
    loadingAnimationActive(o) {
      if (!o) {
        if (this.privacy_policy.user_should_accept) {
          this.$router.push({
            name: "privacy-policy",
            params: { shouldAccept: true }
          });
        } else if (this.terms_of_use.user_should_accept) {
          this.$router.push({
            name: "terms-of-use",
            params: { shouldAccept: true }
          });
        }
      }
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout", this.form)
        .then(() => this.$router.push({ name: "login" }));
    },
    match() {
      this.$store.commit("application/SET_MATCHABLE", this.userId);
      this.$router.push({ name: "match" });
    }
  }
};
</script>
<style>
#warningBodyprint {
  color: red;
}

.someone-else {
  margin-top: 15px;
}
</style>
